<div class="transform-editor">
   <div class="form-group" *ngIf="showTitle">
        <div class="input-group" *ngIf="transformList">
            <select [(ngModel)]="transform" class="form-select">
                <option *ngFor="let t of transformList" [value]="t.id" >{{t.name}}</option>                                  
            </select>
            <button (click)="addTransform(transform)" type="button" class="btn btn-default btn-outline"><i class="bi bi-plus"></i> </button>
        </div>
    </div>
    <div *ngIf="!showTitle">
        <div class="input-group" *ngIf="transformList">
            <select [(ngModel)]="transform" class="form-select">
                <option *ngFor="let t of transformList" [value]="t.id" >{{t.name}}</option>                                  
            </select>
            <button (click)="addTransform(transform)" type="button" class="btn btn-default btn-outline"><i class="bi bi-plus"></i> </button>
        </div>
    </div>
    <br/>
    <div class="mb-3 bg-white bg-opacity-15" *ngIf="transforms && transforms.length > 0 && transformList">
        <div class="list-group" [sortablejs]="transforms" [sortablejsOptions]="sortableOptions">
            <div class="list-group-item d-flex px-3" *ngFor="let t of transforms">
                <div class="me-3 pt-1">
                    <i class="bi bi-arrow-down text-success"></i>
                </div>
                <div class="flex-fill">
                    <div>
                        <span class="flex-grow-1 fw-400">{{t.transform.name}}</span>            
                        <button class="btn btn-outline btn-sm" style="float:right" (click)="removeTransform(t)"><i class="bi bi-trash"></i></button>
                    </div>
                    <div class="row">
                        <div class="col-xs-6 col-sm-12" *ngFor="let param of getTransformDetails(t).parameters; let i = index">
                            <app-parameter [parameter]="param" [configItem]="t.config[i]" [enabled]="true"></app-parameter>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
        
    </div>
    
</div>